import VisitaChat from 'visitaChat';

window.VisitaChat = VisitaChat;